import React from 'react';
import BankingIntro from '../components/BankingIntro/BankingIntro';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const BankingPage = () => {
  return (
    <>
      <BankingIntro />
      <CtaSection />
    </>
  );
};

export default BankingPage;
